import { createContext, useContext } from 'react';

/**
 * A way out a surface offers from a layout it can't fully draw (a saved
 * layout holding a component type this build no longer has): shown on the
 * component's "not available" tile, e.g. "Reset to template".
 */
export interface CanvasRecovery {
  label: string;
  onReset: () => void;
}

export const CanvasRecoveryContext = createContext<CanvasRecovery | null>(null);

export function useCanvasRecovery(): CanvasRecovery | null {
  return useContext(CanvasRecoveryContext);
}
